import { GET_INTERVIEWS } from "./types";

import { db } from "../../firebase/firebase"

export const getInterviews = (id, userType) => async (dispatch) => {

    if (userType === "interviewee") {

        await db
            .collection("scheduleInterview").where("userId", "==", parseInt(id))
            .onSnapshot((res) => {
                let docs = [];
                res.forEach((doc) => {
                    docs.push({
                        _id: doc.id,
                        company: doc.data().company,
                        interviewType: doc.data().interViewType,
                        date: doc.data().date,
                        resumeLink: doc.data().resumeLink,
                        time: doc.data().time,
                        userId: doc.data().userId
                    })
                })

                dispatch({ type: GET_INTERVIEWS, payload: docs })
            })
    }
    else {
        await db
            .collection("scheduleInterview")
            .onSnapshot((res) => {
                let docs = [];
                res.forEach((doc) => {
                    docs.push({
                        _id: doc.id,
                        company: doc.data().company,
                        interviewType: doc.data().interViewType,
                        date: doc.data().date,
                        resumeLink: doc.data().resumeLink,
                        time: doc.data().time,
                        userId: doc.data().userId
                    })
                })

                dispatch({ type: GET_INTERVIEWS, payload: docs })
            })
    }

}